import TagList from './tagList'

const tagList = new TagList()
tagList.init()
